/* RESPONSIBLE TEAM: team-self-serve */
/* eslint-disable ember/no-controllers */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { PRICING_5_1_ADVANCED_SOLUTION_ID } from 'embercom/lib/billing';

export default class ReferralsController extends Controller {
  @service declare intl: any;

  get referralUrl() {
    return `https://app.intercom.com/admins/sign_up?solution_id=${PRICING_5_1_ADVANCED_SOLUTION_ID}&referral_code=${this.model}`;
  }
}
